// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"593":"bd13605b","635":"41f97d48"}[chunkId] + ".chunk.js";
};